import { SIDE_BAR_HEADINGS } from "@faire/retailer-visitor-shared/views/settings/profile/consts";
import { MenuItem } from "@faire/retailer-visitor-shared/views/settings/profile/MenuItem";
import { IMenuItem } from "@faire/retailer-visitor-shared/views/settings/useMenuItems";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { useMemo } from "react";

interface IProps {
  menuItems: IMenuItem[];
  selected: string;
}

type SideBarSectionsMap = {
  [key in SIDE_BAR_HEADINGS]: IMenuItem[];
};

const sideBarSections = (menuItems: IMenuItem[]): SideBarSectionsMap => {
  const sections: SideBarSectionsMap = {
    [SIDE_BAR_HEADINGS.DEFAULT]: [],
    [SIDE_BAR_HEADINGS.SETTINGS]: [],
  };

  menuItems.forEach((menuItem) => {
    sections[menuItem.section ?? SIDE_BAR_HEADINGS.DEFAULT].push(menuItem);
  });

  return sections;
};

export const SideBarRenderer: React.FC<IProps> = ({ menuItems, selected }) => {
  const sections: SideBarSectionsMap = useMemo(() => {
    return sideBarSections(menuItems);
  }, [menuItems]);

  return (
    <Column data-test-id="side-bar-section-renderer">
      <Typography variant="subheadingSansMedium">
        <StrictLocalMsg
          defaultMessage="Settings"
          description={{
            text: "Title informing the retailer that this is the account settings page",
          }}
        />
      </Typography>
      <Spacer size="3x" />
      {Object.keys(sections).map((section, index) => {
        const items = sections[section as SIDE_BAR_HEADINGS];
        if (items.length === 0) {
          return null;
        }

        return (
          <Column key={section}>
            {index !== 0 ? <Spacer size="2x" /> : null}
            {items.map((menuItem) => (
              <MenuItem
                key={menuItem.label}
                menuItem={menuItem}
                isSelected={menuItem.value === selected}
              />
            ))}
          </Column>
        );
      })}
    </Column>
  );
};
